import { common } from '../../../../i18n/common.js';

// вставляє вказані "особливі адреси" в випадаюче меню
// (наприклад, "Моє місцезнаходження", "Домашня адреса", "Адреса роботи" і т.д.)
// dropdown - контейнер для випадаючого меню
export const insertsSpecialAddresses = ({
  dropdown,
  specialAddresses,
  lang = 'en',
}) => {
  // екранування спецсимволів
  // щоб не ламати HTML розмітку
  // і не давати можливість XSS-атак
  const esc = s =>
    String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  // створюємо список, якщо його немає
  let list = dropdown.querySelector('.dropdown-list');
  if (!list) {
    list = document.createElement('ul');
    list.className = 'dropdown-list';
    dropdown.appendChild(list);
  }

  // отримуємо масив адрес для поточної мови
  let items = [];

  if (Array.isArray(specialAddresses)) {
    items = specialAddresses;
  } else {
    items = specialAddresses[lang] || specialAddresses?.en || [];
  }

  // Моє місцезнаходження завжди перша адреса + інші адреси
  list.innerHTML =
    `
    <li class="dropdown-item">
      <button type="button" class="dropdown-button" data-id="my-location">
        <span class="spinner hidden" aria-hidden="true"></span>
        <span class="pac-icon pac-icon-my-location"></span>
        <span class="pac-item-query">${common[lang].my_location}</span>
      </button>
    </li>
  ` +
    `${items
      .map(
        a => `
          <li class="dropdown-item">
            <button type="button" class="dropdown-button" data-id="${esc(
              a.id
            )}">
              <span class="pac-icon pac-icon-marker"></span>
              <span class="pac-matched">${esc(a.firstName || a.name)}</span>
              <span class="pac-item-query"> - ${esc(a.name)}</span>
            </button>
          </li>
        `
      )
      .join('')}`.trim();
};
